import makeFetchUrl from "./util/make-fetch-url";

interface ExtendedRequestInit extends RequestInit {
  body?: any;
  params?: any;
}

async function http(
  url: string,
  { body, params, ...rest }: ExtendedRequestInit = {}
) {
  const headers = { "Content-Type": "application/json" };
  const config: RequestInit = {
    method: body ? "POST" : "GET",
    ...rest,
    headers: {
      ...headers,
      ...rest?.headers,
    },
  };
  // handle body
  if (body) {
    config.body = JSON.stringify(body);
  }
  // handle params
  const fetchUrl = makeFetchUrl(url, params);
  const res = await fetch(fetchUrl, config);

  let json = null;
  try {
    json = await res.json();
  } catch (e) {
    console.error(e, "Http Client: Error parsing JSON");
  }

  return { status: res.status, data: json };
}

export default http;
